import { Capacitor } from '@capacitor/core';
import { preferences } from '@apexx/storage';

const STORAGE_KEY = 'device_id';

/**
 * Returns a stable unique device id.
 * - Native: uses Capacitor Device.getId() (vendor-scoped on iOS, ANDROID_ID on Android).
 * - Web: generates a UUID once and persists via Preferences.
 */
export async function getDeviceId(): Promise<string | undefined> {
	if (Capacitor.isNativePlatform()) {
		try {
			const { Device } = await import('@capacitor/device');
			const { identifier } = await Device.getId();
			return identifier || undefined;
		} catch {
			return undefined;
		}
	}
	try {
		let id = await preferences.getItem(STORAGE_KEY);
		if (!id) {
			id = crypto.randomUUID();
			await preferences.setItem(STORAGE_KEY, id);
		}
		return id;
	} catch {
		return undefined;
	}
}
